import { render, staticRenderFns } from "./GlobalSetDialog.vue?vue&type=template&id=252842c6&scoped=true"
import script from "./GlobalSetDialog.vue?vue&type=script&lang=js"
export * from "./GlobalSetDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalSetDialog.vue?vue&type=style&index=0&id=252842c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252842c6",
  null
  
)

export default component.exports